import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

/**
 * 🔹 Payload para crear/actualizar
 */
export interface PlanPreparacionRespuestaPayload {
  version: string;
  codigo: string;
  fecha_designacion: string; // formato YYYY-MM-DD
  fecha_vencimiento: string; // formato YYYY-MM-DD
  estado?: number;
}

/**
 * 🔹 Interface de respuesta
 */
export interface PlanPreparacionRespuesta {
  id?: number;
  version: string;
  codigo: string;
  fecha_designacion: string;
  fecha_vencimiento: string;
  estado: number;
  fechaCreacion?: string;
  fechaVencimiento?: string | null;
}

export interface PlanPreparacionRespuestaResponse {
  id?: number;
  message?: string;
  error?: string;
  data?: any;
  [key: string]: any;
}

@Injectable({
  providedIn: "root",
})
export class PlanPreparacionRespuestaService {
  private readonly apiUrl = `${environment.apiUrl}/api/plan_preparacion_respuesta`;

  constructor(private http: HttpClient) {}

  // Listar todos los planes de preparación de respuesta
  getAll(): Observable<PlanPreparacionRespuesta[]> {
    return this.http.get<PlanPreparacionRespuesta[]>(this.apiUrl, { withCredentials: true });
  }

  // Obtener por ID
  getById(id: number): Observable<PlanPreparacionRespuesta> {
    return this.http.get<PlanPreparacionRespuesta>(`${this.apiUrl}/${id}`, { withCredentials: true });
  }

  // Crear nuevo plan de preparación de respuesta
  create(payload: PlanPreparacionRespuestaPayload): Observable<PlanPreparacionRespuestaResponse> {
    return this.http.post<PlanPreparacionRespuestaResponse>(this.apiUrl, payload, { withCredentials: true });
  }

  // Actualizar plan de preparación de respuesta
  update(id: number, payload: Partial<PlanPreparacionRespuestaPayload>): Observable<PlanPreparacionRespuestaResponse> {
    return this.http.put<PlanPreparacionRespuestaResponse>(`${this.apiUrl}/${id}`, payload, { withCredentials: true });
  }

  // Eliminar plan de preparación de respuesta (DELETE)
  remove(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${id}`, { withCredentials: true });
  }

  // Inactivar plan de preparación de respuesta
  inactivar(id: number): Observable<PlanPreparacionRespuestaResponse> {
    return this.http.put<PlanPreparacionRespuestaResponse>(`${this.apiUrl}/${id}/inactivar`, {}, { withCredentials: true });
  }

  // Activar plan de preparación de respuesta
  activar(id: number): Observable<PlanPreparacionRespuestaResponse> {
    return this.http.put<PlanPreparacionRespuestaResponse>(`${this.apiUrl}/${id}/activar`, {}, { withCredentials: true });
  }
}